<script setup>
import AlertsPage from '@/components/AlertsPage.vue';
import ToastHost from '@/components/base/ToastHost.vue';

</script>

<template>
  <Suspense>
    <AlertsPage />
  </Suspense>
  <ToastHost />
</template>
